export default __webpack_public_path__ + "static/media/clip.77a0baac.mp4";